import { frontendURL } from '../../../helper/URLHelper'

const TasksView = () => import('./TasksView.vue')
const BulkBroadcastsView = () => import('./bulk-broadcasts/BulkBroadcastsView.vue')

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/tasks'),
      name: 'tasks_calendar',
      component: TasksView,
      meta: {
        permissions: ['agent', 'administrator'],
      },
    },
    {
      // Anidada bajo /tasks para que el grupo Tareas del sidebar quede activo
      // por el fallback de prefijo de SidebarGroup.
      path: frontendURL('accounts/:accountId/tasks/bulk-broadcasts'),
      name: 'bulk_broadcasts_index',
      component: BulkBroadcastsView,
      meta: {
        permissions: ['agent', 'administrator'],
      },
    },
  ],
}
